import styled from 'styled-components';

const ToolBarNav = styled.nav`
  background: ${({ theme }) => theme.palette.background.special};
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  height: 50px;
  padding: ${({ theme }) => `${theme.spacing(1)}`};
`;

export { ToolBarNav };
